import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'CommunityLocation',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    communityId: String,
    locationId: String
  },
  data () {
    return {
      loading: true
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.resetDetail()
  },
  computed: {
    ...mapState({
      categoryName: state => state.communityLocation.categoryName,
      // model
      values: state => state.communityLocation.values
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      getValue: 'communityLocation/getValue',
    })
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      loadModel: 'communityLocation/loadModel',
      resetDetail: 'communityLocation/reset',
    }),

    init () {
      this.loading = true

      // パラメータ
      let locationParams = {
        locationUuid: this.locationId
      }

      // データ読出し
      this.loadModel({
        targetId: this.locationId,
        locationParams: locationParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    }
  }
}